import { UserInterface } from 'app/core/user/models/user.model';

export interface TokenInterface {
  exp?: number;
  scopes?: string[];
  loggedInUser?: UserInterface;
}

export class Token implements TokenInterface {
  public exp?: number;
  public scopes?: string[];
  public loggedInUser?: UserInterface;

  constructor({
    exp = undefined,
    scopes = undefined,
    loggedInUser = undefined,
    }: TokenInterface) {
    this.exp = exp;
    this.scopes = scopes;
    this.loggedInUser = loggedInUser;
  }
}
